import { createStore } from 'vuex';

import saleOrdersModule from './modules/saleOrders/saleOrders.store';

import rootActions from './actions';
import rootGetters from './getters';
import rootMutations from './mutations';

export default createStore({
  state: {
    allCustomers: [],
    saleOrderStates: [],
  },
  modules: {
    saleOrders: saleOrdersModule,
  },
  mutations: rootMutations,
  actions: rootActions,
  getters: rootGetters,
});
